'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VerifyChildrenOrder = require('./VerifyChildrenOrder');

var _VerifyChildrenOrder2 = _interopRequireDefault(_VerifyChildrenOrder);

var _VideoActions = require('../../shared/VideoActions');

var _Injection = require('../../shared/VideoStore/Injection');

var _style = require('./style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2013-2015, Hudl
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @providesModule ContextProvider
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ContextProvider = function (_React$Component) {
  _inherits(ContextProvider, _React$Component);

  function ContextProvider() {
    _classCallCheck(this, ContextProvider);

    return _possibleConstructorReturn(this, (ContextProvider.__proto__ || Object.getPrototypeOf(ContextProvider)).apply(this, arguments));
  }

  _createClass(ContextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        actions: _VideoActions.actions,
        playables: [] || this.props.contextState.playables,
        playerId: this.props.playerId,
        state: this.props.contextState,
        store: _extends({
          injectAction: _Injection.injectAction,
          injectEventListener: _Injection.injectEventListener,
          injectStateKeys: _Injection.injectStateKeys,
          removeEventListener: _Injection.removeEventListener,
          removeAction: _Injection.removeAction,
          removeStateKeys: _Injection.removeStateKeys
        }, this.context.store)
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (process.env.NODE_ENV !== 'production') {
        (0, _VerifyChildrenOrder2.default)(this.children());
      }
    }

    /*
     * react makes performance decisions to allow props.children
     * to be an array or object based on what jsx renders to.
     *
     * For API simplicity, we are forcing to an array
     */

  }, {
    key: 'children',
    value: function children() {
      return _react2.default.Children.toArray(this.props.children);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _style.contextProviderContainer },
        this.props.children
      );
    }
  }]);

  return ContextProvider;
}(_react2.default.Component);

ContextProvider.propTypes = {
  children: _propTypes2.default.node,
  contextState: _propTypes2.default.object.isRequired,
  playerId: _propTypes2.default.string
};
ContextProvider.contextTypes = {
  store: _propTypes2.default.object.isRequired
};
ContextProvider.childContextTypes = {
  actions: _propTypes2.default.object.isRequired,
  state: _propTypes2.default.object.isRequired,
  store: _propTypes2.default.object.isRequired,
  playables: _propTypes2.default.array.isRequired,
  playerId: _propTypes2.default.string.isRequired
};
exports.default = ContextProvider;
module.exports = exports['default'];